import { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { baseColors, BaseStack } from "goi_common/src/design-system";
import { HEADER_HEIGHT, SECOND_HEADER_HEIGHT } from "@/constants/components";

const BANNER_TOP_MOBILE = HEADER_HEIGHT + SECOND_HEADER_HEIGHT + 16;
const BANNER_TOP_DESKTOP = HEADER_HEIGHT + 16;
const PC_BREAKPOINT = 1024;

interface FomoReassuranceBannerProps {
  variant?: "fomo" | "quiz_coupon";
}

export function FomoReassuranceBanner({
  variant = "fomo",
}: FomoReassuranceBannerProps) {
  const [bannerTop, setBannerTop] = useState(BANNER_TOP_MOBILE);

  useEffect(() => {
    const isPC = () => window.innerWidth >= PC_BREAKPOINT;

    const updateBannerTop = () => {
      setBannerTop(isPC() ? BANNER_TOP_DESKTOP : BANNER_TOP_MOBILE);
    };

    updateBannerTop();
    window.addEventListener("resize", updateBannerTop, { passive: true });
    return () => {
      window.removeEventListener("resize", updateBannerTop);
    };
  }, []);

  return (
    <Box
      position="fixed"
      top={`${bannerTop}px`}
      left="50%"
      transform="translateX(-50%)"
      width="calc(100% - 32px)"
      maxWidth="440px"
      zIndex={1000}
      background={baseColors.label_normal}
      borderRadius="12px"
      px="16px"
      py="10px"
    >
      <BaseStack spacing={4} alignItems="flex-start">
        <Box
          className="body_1_normal_sb"
          color={baseColors.white}
          whiteSpace="nowrap"
        >
          {variant === "quiz_coupon" ? (
            <>
              🎁{" "}
              <span style={{ color: baseColors.red_300 }}>
                10만원 할인 쿠폰
              </span>
              이 적용됐어요
            </>
          ) : (
            <>
              <span style={{ color: baseColors.red_300 }}>
                10만원 추가 할인
              </span>
              이 적용됐어요
            </>
          )}
        </Box>
        <Box
          className="body_1_normal_sb"
          color={baseColors.white}
          whiteSpace="nowrap"
        >
          {variant === "quiz_coupon"
            ? "지금 가입 시 할인된 금액으로 이용하실 수 있어요"
            : "지금 가입을 완료하지 않으면 혜택이 사라져요"}
        </Box>
      </BaseStack>
    </Box>
  );
}
